/*
 *  LayoutHeader.tsx
 * This Component is used to manage menu functionality in a single header and we'll use it all over the project.
 */

import UserProfile from "./user-profile";
import styles from "./layout-header.module.css";

type TProps = {
  onToggleSideBar: Function;
  sideBarStatus: boolean;
};

export default function LayoutHeader(props: TProps) {

  return (
    <div className={styles.header}>
      <div className={styles.logoSize}>
        <div className={styles.welcomelogo}></div>
      </div>

      <div className={styles.headerMenu}>
        <div className={styles.userProfileIcon}>
          <UserProfile />
        </div>
        <div className={styles.gearicon}>
        </div>
      </div>
    </div>
  );
}
